export default __webpack_public_path__ + "static/media/Update Business Pricing Tiers.92a5ab61.xlsx";